import React from 'react';
import StaticPage from '../../components/layouts/StaticPage';

function Contact() {
  return (
    <StaticPage>
      <h1>Kontakt</h1>

      <h2>
        Per E-Mail: <a href="mailto:team@triff.app">team@triff.app </a>
      </h2>
      <h2>
        Per Telefon: <a href="tel:+41445866870">+41 44 586 68 70</a>
      </h2>
      <h2>Per Post:</h2>
      <p>
        Ganz digital GmbH <br />
        Bönirainstrasse 16 <br />
        8800 Thalwil <br />
        Switzerland <br />
      </p>
    </StaticPage>
  );
}

export default Contact;
